<template>
  <div
    :style="`background-color: ${color};`"
    :class="['c-sticker c-sticker-mobile', index === 0 ? 'u-marg-t-lg--md' : '', ]">

    <div
      :style="`background-color: ${color};`"
      class="c-sticker__thumbnail">
        <img class="lazyload" :data-src="img" :alt="`sticker ${color}`">
    </div>

    <span class="c-sticker__caption">{{ text }}</span>
  </div>
</template>

<script>
  export default {
    name: 'Sticker',
    props: {
      index: {
        type: Number,
        default: () => 0
      },
      text: {
        type: String,
        default: () => ''
      },
      img: {
        type: String,
        default: () => ''
      },
      color: {
        type: String,
        default: () => '#00ffff'
      }
    },
  }
</script>